import React from 'react';
import Text from '@splunk/dashboard-visualizations/Text';

export default () => (
    <Text
        options={{
            content: 'Content Text',
            fontSize: 48,
        }}
    />
);
